import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBettingSelection } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";

export const useDeleteBettingSelection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteBettingSelection(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BettingSelectionsQueryKeys.BettingSelections] });
    },
  });
};
